"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
var mediaQueries_1 = __importDefault(require("../tokens/mediaQueries"));
var borderWidths_1 = require("./borderWidths");
var colors_1 = require("./colors");
var fontFamilies_1 = require("./fontFamilies");
var fontSizes_1 = require("./fontSizes");
var fontWeights_1 = require("./fontWeights");
var letterSpacings_1 = require("./letterSpacings");
var lineHeights_1 = require("./lineHeights");
var opacities_1 = require("./opacities");
var radii_1 = require("./radii");
var shadows_1 = require("./shadows");
var spacing_1 = require("./spacing");
var zIndices_1 = require("./zIndices");
exports.theme = {
    colors: colors_1.colors,
    fontSizes: fontSizes_1.fontSizes,
    fontWeights: fontWeights_1.fontWeights,
    fonts: fontFamilies_1.fontFamilies,
    lineHeights: lineHeights_1.lineHeights,
    opacity: opacities_1.opacities,
    radii: radii_1.radii,
    shadows: shadows_1.shadows,
    zIndices: zIndices_1.zIndices,
    space: spacing_1.spacing,
    borderWidths: borderWidths_1.borderWidths,
    letterSpacings: letterSpacings_1.letterSpacings,
    mediaQueries: mediaQueries_1.default,
    breakpoints: [mediaQueries_1.default.small, mediaQueries_1.default.medium, mediaQueries_1.default.large],
};
__exportStar(require("./colors"), exports);
__exportStar(require("./fontSizes"), exports);
__exportStar(require("./fontWeights"), exports);
__exportStar(require("./fontFamilies"), exports);
__exportStar(require("./lineHeights"), exports);
__exportStar(require("./opacities"), exports);
__exportStar(require("./radii"), exports);
__exportStar(require("./shadows"), exports);
__exportStar(require("./zIndices"), exports);
__exportStar(require("./spacing"), exports);
__exportStar(require("./borderWidths"), exports);
__exportStar(require("./letterSpacings"), exports);
//# sourceMappingURL=index.js.map